// Email address is composed programmatically so it never appears as plain text in markup.
const USER = "ryder.kat";
const DOMAIN = "gmail.com";
const SUBJECT = "Project%20inquiry";

export const MAILTO = `mailto:${USER}@${DOMAIN}?subject=${SUBJECT}`;
